export function bindPatientSearchOverlayScroll(): () => void {
  document.body.classList.add('patient-search-overlay-open');

  const onWheel = (event: WheelEvent) => {
    const panel = document.querySelector('.patient-search-ac-panel') as HTMLElement | null;
    if (!panel) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    if (!panel.contains(event.target as Node)) {
      return;
    }

    const scroller =
      (panel.querySelector('.p-autocomplete-items, .p-autocomplete-list, .p-scroller') as HTMLElement) ||
      panel;

    scroller.scrollTop += event.deltaY;
  };

  document.addEventListener('wheel', onWheel, { capture: true, passive: false });

  return () => {
    document.body.classList.remove('patient-search-overlay-open');
    document.removeEventListener('wheel', onWheel, true);
  };
}
